import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeviationResourceType, getTranslatedDeviationTitle } from '../../../DeviationViews/_helpers';
import { DeviationDuperbrowseContext, DeviationLink } from '../../../Duperbrowse';
import DeviationDumbViewWithIcon from '../../../DeviationViews/DumboWithIcon';
import SidebarGrid from '../SidebarGrid';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Grid from '../../../Grid/MeasuredGrid';
import { MeasuredCookieType } from '../../../Measured';
const DeviationSidebarGrid = ({ streamId, deviations, parentDeviation, maxRows, className })=>{
    const { t } = useTranslation();
    const preloadEnabled = false;
    const isResponsiveFyltGrid = useFlag('responsive_fylt_grid');
    const renderDeviation = useCallback(({ item, width, height, className: itemClassName })=>/*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: item,
            key: item.deviationId,
            className: itemClassName,
            title: getTranslatedDeviationTitle(item, t)
        }, /*#__PURE__*/ React.createElement(DeviationDumbViewWithIcon, {
            deviation: item,
            width: width,
            height: height,
            greenLikeCrop: true
        })), [
        t
    ]);
    const renderItem = useCallback(({ height, width, index, style })=>{
        const item = deviations[index];
        return /*#__PURE__*/ React.createElement("div", {
            style: style,
            key: index
        }, /*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: item,
            key: item.deviationId,
            title: getTranslatedDeviationTitle(item, t)
        }, /*#__PURE__*/ React.createElement(DeviationDumbViewWithIcon, {
            deviation: item,
            width: width,
            height: height,
            greenLikeCrop: true
        })));
    }, [
        deviations,
        t
    ]);
    return /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: streamId,
        deviations: deviations,
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        },
        preloadEnabled: preloadEnabled
    }, isResponsiveFyltGrid && /*#__PURE__*/ React.createElement(Grid, {
        lazyloadFromContext: true,
        enableScrollOptim: false,
        containerWidth: 308,
        defaultSize: {
            desktop: {
                width: 308,
                height: 308
            },
            mobile: {
                width: 308,
                height: 308
            }
        },
        cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR,
        maxRows: maxRows,
        breakpoints: [
            {
                maxWidth: 600,
                elementsPerRow: 3,
                elementAspectRatio: 1
            }
        ],
        spacing: 16,
        elementCount: deviations.length,
        renderElement: renderItem
    }), !isResponsiveFyltGrid && /*#__PURE__*/ React.createElement(SidebarGrid, {
        items: deviations,
        maxRows: maxRows,
        className: className,
        renderItem: renderDeviation
    }));
};
DeviationSidebarGrid.displayName = 'DeviationSidebarGrid';
export default DeviationSidebarGrid;
